// middleware/error-handler.global.ts
export default defineNuxtRouteMiddleware((to) => {
  // Só executa no cliente
  if (typeof window === 'undefined') return;

  // Intercepta erros globais do JavaScript
  const originalOnError = window.onerror;
  const originalOnUnhandledRejection = window.onunhandledrejection;

  window.onerror = function(message, source, lineno, colno, error) {
    const errorMessage = typeof message === 'string' ? message : message.toString();
    
    // Trata erros específicos do storage
    if (errorMessage.includes('Access to storage is not allowed')) {
      console.warn('[Storage Error Handler] Storage access blocked, clearing problematic data');
      
      // Lista de chaves que podem estar causando problema
      const problematicKeys = [
        'pinia:token-store',
        'pinia:module-store', 
        'pinia:telao-store',
        'pinia:AuthStore',
        'pinia:rss-feed-store'
      ];

      problematicKeys.forEach(key => {
        try {
          localStorage.removeItem(key);
          sessionStorage.removeItem(key);
        } catch (e) {
          // Ignora erros ao tentar remover
        }
      });

      // Recarrega a página após limpar o storage
      setTimeout(() => {
        window.location.reload();
      }, 100);
      
      return true; // Previne o erro padrão
    }

    // Trata erros do unhead
    if (
      errorMessage.includes('getActiveHead') ||
      errorMessage.includes('unhead/dist/index.mjs') ||
      errorMessage.includes('does not provide an export named')
    ) {
      console.warn('[Unhead Error Handler] Suppressed unhead import error');
      return true; // Previne o erro padrão
    }

    // Chama o handler original para outros erros
    if (originalOnError) {
      return originalOnError.call(this, message, source, lineno, colno, error);
    }
    
    return false;
  };

  window.onunhandledrejection = function(event) {
    const errorMessage = event.reason?.message || event.reason?.toString() || '';
    
    // Trata promisses rejeitadas relacionadas ao storage
    if (errorMessage.includes('Access to storage is not allowed')) {
      console.warn('[Storage Promise Handler] Storage access blocked in promise');
      event.preventDefault(); // Previne que a promise rejection apareça no console
      return;
    }

    // Trata erros do unhead em promises
    if (
      errorMessage.includes('getActiveHead') ||
      errorMessage.includes('unhead') ||
      errorMessage.includes('does not provide an export named')
    ) {
      console.warn('[Unhead Promise Handler] Suppressed unhead promise error');
      event.preventDefault();
      return;
    }

    // Chama o handler original para outras promises
    if (originalOnUnhandledRejection) {
      return (originalOnUnhandledRejection as (this: Window, ev: PromiseRejectionEvent) => any).call(window, event);
    }
  };

  // Limpa os handlers quando a rota muda
  const cleanup = () => {
    window.onerror = originalOnError;
    window.onunhandledrejection = originalOnUnhandledRejection;
  };

  // Limpa ao navegar para outra página
  if (to.path !== window.location.pathname) {
    cleanup();
  }
});